var chunkMapping = {
	"33": [
		9033
	],
	"79": [
		9079
	],
	"307": [
		6307
	],
	"388": [
		9033
	],
	"395": [
		956,
		1408,
		6899
	],
	"507": [
		5507
	],
	"938": [
		9033
	],
	"956": [
		956
	]
};
var idToExternalAndNameMapping = {
	"956": [
		"default",
		"./AppConfig",
		6196
	],
	"1408": [
		"default",
		"./Slots",
		6196
	],
	"5507": [
		"default",
		"./AuthModule",
		6196
	],
	"6307": [
		"default",
		"./BusinessModule",
		6196
	],
	"6899": [
		"default",
		"./ContainedOverlays",
		6196
	],
	"9033": [
		"default",
		"./Services",
		6196
	],
	"9079": [
		"default",
		"./WelcomeModule",
		6196
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}